import type React from 'react';
import { PropTypes } from '@elliemae/ds-props-helpers';
import type { Theme } from '@elliemae/pui-theme';

export interface MobileCardProps {
  children: React.ReactNode | React.ReactNode[];
  height: 's' | 'm';
  leftAddOn: JSX.Element | JSX.Element[];
  leftProp: JSX.Element | JSX.Element[];
  rightProp: JSX.Element[];
  subText: string[];
  subIcons: JSX.Element | JSX.Element[];
  details: string[];
  theme: Theme;
  value: number;
  expandable: boolean;
  expandedContent: JSX.Element | JSX.Element[];
  cardContent: JSX.Element | JSX.Element[];
}

export const cardPropsTypes = {
  /**
   * card height
   */
  height: PropTypes.oneOf(['s', 'm']).description('card height'),
  /**
   * Defines mobile card title
   */
  children: PropTypes.string.description('Defines mobile card title').isRequired,
  /**
   * Wheter if the card is expandable or not
   */
  expandable: PropTypes.bool.description('Wheter if the card is expandable or not'),
  /**
   * content to display in expand card section
   */
  expandedContent: PropTypes.element.description('content to display in expand card section'),
  /**
   * Icon to the left of the card. Size is adjusted automatically.
   */
  leftAddOn: PropTypes.element.description('Icon to the left of the card. Size is adjusted automatically.'),
  /**
   * Pass an element to render left. For example a Button with an icon
   */
  leftProp: PropTypes.element.description('Pass an element to render left. For example a Button with an icon'),
  /**
   * Pass an array of 1 or 2 elements to render right. For example a Button with an icon
   */
  rightProp: PropTypes.arrayOf(PropTypes.element).description(
    'Pass an array of 1 or 2 elements to render right. For example a Button with an icon',
  ),
  /**
   * Pass an array of 1 or 2 strings
   */
  subText: PropTypes.arrayOf(PropTypes.string).description('Pass an array of 1 or 2 strings'),
  /**
   * SubIcons component
   */
  subIcons: PropTypes.element.description('SubIcons component'),
  /**
   * Pass an array of 1, 2 or 3 strings
   */
  details: PropTypes.arrayOf(PropTypes.string).description('Pass an array of 1, 2 or 3 strings'),
  theme: PropTypes.object.description('').isRequired,
  value: PropTypes.number.description(''),
  cardContent: PropTypes.node.description('JSX content for the card'),
};
